import { Modal, Box, Typography, FormControl, TextField, Button, useTheme, FormLabel, MenuItem, Select } from "@mui/material";
import React, { useContext } from "react";
import { AIVerificationResult } from "../../../api";
import { inspectionsApi } from "../../../api-interface";
import { TenantContext } from "../../..";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useSnackbar } from "notistack";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from "yup"



const OverrideModal = ({ open, handleClose, analysisId, verificationResult }: { open: boolean, handleClose: () => void, analysisId: string, verificationResult: AIVerificationResult }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        minWidth: 100,
        p: 4,
    };
    const theme = useTheme()
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const tenant = useContext(TenantContext)
    const [newOutcome, setNewOutcome] = React.useState<boolean>(verificationResult.outcome)

    const handleOverride = async (x) => {
        try{
            await inspectionsApi(tenant).overrideValidationInspectionsAnalysisIdValidationOutcomeIdPatch(analysisId, verificationResult.id, newOutcome, x.reason)
            enqueueSnackbar("Validation Overriden", { variant: "success" })
            navigate("")
            handleClose()
        } catch (e) {
            if (e?.response?.data?.detail) {
                enqueueSnackbar(e.response.data.detail, { variant: "error" })
            } else {
                enqueueSnackbar("Error: " + e, { variant: "error" })
            }
        }
    }

    const schema = yup
        .object({
            reason: yup.string().required('A reason must be given')
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })
    

    return <Modal
        open={open}
        onClose={() => {
            handleClose()
        }}
    >
        <Box sx={style} display="flex" flexDirection={"column"} gap={2}>
            <Typography variant="h6">Override Verification Outcome</Typography>
            <Box>
                <Typography fontWeight={"bold"}>{verificationResult.validation_name}</Typography>
                <Typography>{verificationResult.validation_desc}</Typography>
            </Box>
            <Box display="flex" flexDirection={"column"} gap={2}>
                <FormControl>
                    <FormLabel>Outcome</FormLabel>
                    <Select
                        value={newOutcome}
                        disableUnderline
                        onChange={(e) => { setNewOutcome(e.target.value as boolean) }}
                    >
                        <MenuItem color='inherit' key={"true"} value={true.toString()}><Typography color={theme.palette.success.main}> <TaskAltIcon fontSize="inherit" /> Compliant </Typography></MenuItem>
                        <MenuItem color='inherit' key={"false"} value={false.toString()}> <Typography color={verificationResult.severity == "error" ? theme.palette.error.main : theme.palette.warning.main}><ErrorOutlineIcon fontSize="inherit" /> {verificationResult.severity == "error" ? "Needs Attention" : "Warning"}</Typography> </MenuItem>
                    </Select>
                </FormControl>
                <FormControl>
                    <FormLabel>Reason</FormLabel>
                    <TextField
                        variant="outlined"
                        multiline
                        {...register('reason')}
                        placeholder="Reason for override"
                        rows={4}
                    />
                    <Typography display={errors.reason ? "inherit" : "none"} fontSize={"small"} color={theme.palette.error.main}>{errors.reason?.message}</Typography>
                </FormControl>
                <Button
                    variant="contained"
                    onClick={handleSubmit(handleOverride)}
                >Override</Button>
            </Box>
        </Box>
    </Modal>
}
export default OverrideModal